var storage_source="local";

class recentView
{
    constructor(viewid,count,source) {
        this.viewid = viewid;
        this.count = count;
        this.sessionid ="recentlyViewed";
        this.source =source;
        
        const url = window.location.href;
        //console.log(url);
        if(url.includes(this.viewid)){
            //testing-console.log('hvhj');
            const viewIndex = url.indexOf(this.viewid);
            if (viewIndex !== -1) {
               
              const viewInfo = url.substring(viewIndex + 9);
              this.trackRecentlyViewed(viewInfo);
            }
            
        }
    }

    trackRecentlyViewed(viewURL) {
      
        if(this.source == 'local'){
            this.trackRecentlyViewedLocal(viewURL);
        }
        else {
            this.trackRecentlyViewedSession(viewURL);
        }
    }

    trackRecentlyViewedSession(viewURL) {
      
        let recentlyViewed = JSON.parse(sessionStorage.getItem(this.sessionid)) || [];
      
        const index = recentlyViewed.indexOf(viewURL);
      
        if (index !== -1) {
            recentlyViewed.splice(index, 1);
        }
      
        recentlyViewed.unshift(viewURL);
        const maxRecentlyViewedPages = this.count;
        if (recentlyViewed.length > maxRecentlyViewedPages) {
            recentlyViewed = recentlyViewed.slice(0, maxRecentlyViewedPages);
        }
       //testing-console.log('added');
        sessionStorage.setItem(this.sessionid, JSON.stringify(recentlyViewed));
    }

    trackRecentlyViewedLocal(viewURL) {
      
        let recentlyViewed = JSON.parse(localStorage.getItem(this.sessionid)) || [];
      
        const index = recentlyViewed.indexOf(viewURL);
      
        if (index !== -1) {
            recentlyViewed.splice(index, 1);
        }
      
        recentlyViewed.unshift(viewURL);
        const maxRecentlyViewedPages = this.count;
        if (recentlyViewed.length > maxRecentlyViewedPages) {
            recentlyViewed = recentlyViewed.slice(0, maxRecentlyViewedPages);
        }
       //testing-console.log('added');
       localStorage.setItem(this.sessionid, JSON.stringify(recentlyViewed));
    }

    getRecentlyViewed(count) {
        if(this.source == 'local'){
            return this.getRecentlyViewedLocal(count);
        }
        else {
            return this.getRecentlyViewedSession(count);
        }
    }

    getRecentlyViewedSession(count) {
        const recentlyViewed = JSON.parse(sessionStorage.getItem(this.sessionid)) || [];
        if (count && count > 0 && count <= recentlyViewed.length) {
            return recentlyViewed.slice(0, count);
        }
        return recentlyViewed;
    }

    getRecentlyViewedLocal(count) {
        const recentlyViewed = JSON.parse(localStorage.getItem(this.sessionid)) || [];
        if (count && count > 0 && count <= recentlyViewed.length) {
            return recentlyViewed.slice(0, count);
        }
        return recentlyViewed;
    }
}

 /**
 *  @class
 *  @function ProductRecentlyViewed
 */

 class ProductRecentlyViewed extends HTMLElement {
	constructor() {
		super();
        this.sessionid ="recentlyViewed";
        this.source = storage_source || 'session';
	}

  getRecentlyViewed(count) {
    
    if(this.source == 'local'){
        return this.getRecentlyViewedLocal(count);
    }
    else {
        return this.getRecentlyViewedSession(count);
    }
  }


  getRecentlyViewedSession(count) {
    const recentlyViewed = JSON.parse(sessionStorage.getItem(this.sessionid)) || [];
    if (count && count > 0 && count <= recentlyViewed.length) {
        return recentlyViewed.slice(0, count);
    }
    return recentlyViewed;
  }

  getRecentlyViewedLocal(count) {
    const recentlyViewed = JSON.parse(localStorage.getItem(this.sessionid)) || [];
    if (count && count > 0 && count <= recentlyViewed.length) {
        return recentlyViewed.slice(0, count);
    }
    return recentlyViewed;
  }

  fetchAllProductData() {
    
    const productHandles  = this.getRecentlyViewed();
    const fetchPromises = productHandles.map((handle, index) => this.fetchProductData(handle, index));
    return Promise.all(fetchPromises);
  }


  fillProductCard(product,data){
    
    product.classList.add('card-fill-true');
    product.querySelectorAll('.product-card-title').forEach(element => {
        if (element.hasAttribute('title')) {
            element.setAttribute('title', data['product'].title);
        }
        if (element.hasAttribute('href')) {
            element.setAttribute('href', '/products/' + data['product'].handle);
        }
        element.innerHTML = data['product'].title;
      });

      product.querySelectorAll('.product-card-link a').forEach(element => {

        if (element.hasAttribute('href')) {
            element.setAttribute('href', '/products/' + data['product'].handle);
        }
      });

      product.querySelectorAll('.product-featured-image-link').forEach(element => {
        const imagePaddingName = '--padding-bottom';
        const imagePaddingValue = '100%';
        element.setAttribute('style', `${imagePaddingName}: ${imagePaddingValue}`);

        if (element.hasAttribute('title')) {
            element.setAttribute('title', data['product'].title);
        }
        if (element.hasAttribute('href')) {
            element.setAttribute('href', '/products/' + data['product'].handle);
        }
        
        let image_src = data['product']['image'].src;
            image_src = image_src.replace('https:','');
        let image_src_alt = data['product']['image'].alt;
        
        let image_template =`
        <img
            class=""
            sizes="(min-width: 768px) calc((78.59vw / 100 * 83.33333 - 50px) / 4 - 30px), calc(83.25vw - 15px)"
            src="${image_src}&width=2023"
            srcset="
            ${image_src}&width=179 179w,
            ${image_src}&width=239 239w,
            ${image_src}&width=258 258w,
            ${image_src}&width=341 341w,
            ${image_src}&width=360 360w,
            ${image_src}&width=512 512w,
            ${image_src}&width=597 597w,
            ${image_src}&width=682 682w
            "
            alt="${image_src_alt}"
            loading="lazy"
            width="2048"
            height="2048"
        />
        `;
        element.innerHTML = image_template;
      });
  }

  fetchProductData(handle, index) {
    const apiUrl = `/products/${handle.replace('/','')}.json`;
    
    return fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        
        let products = this.querySelectorAll('.product-card');
        if(index < products.length){
           let productCard = products[index];
           this.fillProductCard(productCard,data);
        }
        
      }).finally(() => {
      })
      .catch(error => {
        console.error(`Error fetching product data for ${handle}:`, error);
        return null;
      });
  }

	fetchProducts() {
    this.fetchAllProductData()
    .then(products => {
      let productsEmpty = this.querySelectorAll('.product-card:not(.card-fill-true)');
      productsEmpty.forEach((element) => {
        element.style.setProperty('display', 'none');
      });
      if (productsEmpty.length === this.querySelectorAll('.product-card').length) return;
      this.classList.add('product-recently-viewed--loaded');
    });
 
	}

	connectedCallback() {
        let isInitial = false

        const init = () => {
            if (isInitial) return;
            this.fetchProducts();
            isInitial = true;

            events.forEach((event) => {
                window.removeEventListener(event, init, { passive: true })
            })
        }

        const events = ['mouseover', 'keydown', 'touchmove', 'touchstart'];
        events.forEach((event) => {
            window.addEventListener(event, init, { passive: true })
        })
    }
}

customElements.define('product-recently-viewed', ProductRecentlyViewed);

window.addEventListener('load', () => {
    if (typeof recentView !== 'undefined') {
		new recentView('/products/',5, storage_source);
	}
});